import React, { useMemo, useState } from 'react';
import { ClientFields, QuoteRequestFields } from './QuoteFields';

const createInitialForm = () => ({
  companyName: '',
  contactName: '',
  email: '',
  phone: '',
  location: '',
  message: '',
  attachment: null,
});

const QuoteModal = ({ isOpen, onClose }) => {
  const [form, setForm] = useState(createInitialForm);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const attachmentName = useMemo(
    () => (form.attachment ? form.attachment.name : ''),
    [form.attachment]
  );

  if (!isOpen) {
    return null;
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
    setForm((prev) => ({ ...prev, attachment: file }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Placeholder para integrar envio al backend cuando el servicio exista.
    // eslint-disable-next-line no-console
    console.info('Quote modal payload listo para backend:', form);
    setIsSubmitted(true);
  };

  const handleClose = () => {
    setIsSubmitted(false);
    onClose();
  };

  return (
    <div className="quote-modal-overlay" role="presentation" onClick={handleClose}>
      <div className="quote-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="quote-modal-close" onClick={handleClose} aria-label="Cerrar">
          x
        </button>

        <h2>Cotizacion</h2>

        {!isSubmitted ? (
          <form className="quote-form" onSubmit={handleSubmit}>
            <ClientFields values={form} onChange={handleChange} />
            <QuoteRequestFields values={form} onChange={handleChange} onFileChange={handleFileChange} />

            {attachmentName && <p className="quote-attachment-name">Archivo seleccionado: {attachmentName}</p>}

            <button type="submit" className="public-solid-button">
              Enviar cotizacion
            </button>
          </form>
        ) : (
          <div className="quote-success">
            <p>Gracias por tu solicitud. El formulario ya esta listo para conectarse al backend.</p>
            <button type="button" className="public-solid-button" onClick={handleClose}>
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteModal;
